export default __webpack_public_path__ + "static/media/pumpkin.4fbe58bd.png";